/* People's Peps customizer-safe theme behaviour.
   Global wiring is delegated + guarded; per-section work re-runs on shopify:section:load. */
(function () {
  'use strict';

  /* Run once, however many times this file is included.

     pp-head.liquid is rendered by BOTH the header and the footer section, so
     the browser sees two <script src> tags for this file. A classic script is
     fetched once from cache but EXECUTED once per tag - only ES modules are
     de-duplicated by URL. The __ppGlobalWired flag below only ever protected
     the delegated block; the shopify:section:load and pp:cart:refresh
     listeners at the bottom sat outside it and were being bound twice. */
  if (window.__ppThemeLoaded) return;
  window.__ppThemeLoaded = true;

  /* ---------------------------------------------------------
     1. GLOBAL, DELEGATED WIRING  (bound once, survives re-render)
     --------------------------------------------------------- */
  if (!window.__ppGlobalWired) {
    window.__ppGlobalWired = true;

    // --- mobile drawer -------------------------------------
    function setDrawer(open) {
      document.querySelectorAll('[data-pp-drawer]').forEach(function (d) {
        d.setAttribute('data-open', open ? 'true' : 'false');
        d.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pp-drawer-open]')) { e.preventDefault(); setDrawer(true); return; }
      if (e.target.closest('[data-pp-drawer-close]')) { e.preventDefault(); setDrawer(false); return; }
      var panel = e.target.closest('.pp-drawer__panel');
      var inDrawer = e.target.closest('[data-pp-drawer]');
      if (inDrawer && !panel) { setDrawer(false); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });

    // --- carousel dots -------------------------------------
    // Removed. Nothing in the theme emits data-pp-dot: the rails are built by
    // sliders() in pp-pdp.js, which creates its own buttons with data-pp-page
    // and binds them directly. A second delegate here could only ever fight
    // with that one, so there is a single owner.

    // --- ajax add to cart ----------------------------------
    // Removed. pp-pdp.js owns this now: it renders the cart drawer and
    // opens it, where this one only updated the bubble. Both listened on
    // document for the same submit, so every Add to Cart fired twice and
    // added two of everything. One owner only.

    // --- scroll reveal -------------------------------------
    // Blocks that arrive on screen together rise in a short cascade.
    window.__ppReveal = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries, obs) {
          var k = 0;
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var el = en.target;
            el.style.transitionDelay = Math.min(k * 60, 360) + 'ms';
            k++;
            el.classList.remove('is-pending');
            el.classList.add('is-in');
            obs.unobserve(el);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 })
      : null;
  }

  /* ---------------------------------------------------------
     2. PER-SECTION INIT  (idempotent, keyed by data flags)
     --------------------------------------------------------- */
  // Anything already on the first screen when the page opens stays as it
  // is: it was painted before this script ran, and hiding it until now is
  // what left the header over an empty page on every page change. Only
  // blocks further down are held back (is-pending) and rise in on scroll.
  function initReveal(root) {
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var still = (window.Shopify && window.Shopify.designMode) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    root.querySelectorAll('.pp-rise').forEach(function (el) {
      if (el.dataset.ppRise === '1') return;
      el.dataset.ppRise = '1';
      if (el.classList.contains('is-in')) return;
      if (still || !window.__ppReveal || el.getBoundingClientRect().top < vh) {
        el.classList.add('is-in');
        return;
      }
      el.classList.add('is-pending');
      window.__ppReveal.observe(el);
    });
  }

  // initRails() removed. It looked for [data-pp-dots="<railId>"], but the
  // markup emits data-pp-dots-for, so its guard returned on every element and
  // nothing after it ever ran. sliders() in pp-pdp.js does this job properly.

  function initMarquee(root) {
    root.querySelectorAll('[data-pp-marquee]').forEach(function (row) {
      if (row.dataset.ppMarqueeInit === '1') return;
      row.dataset.ppMarqueeInit = '1';
      var track = row.querySelector('.pp-marquee__track');
      if (!track || !track.children.length) return;
      // duplicate once so translateX(-100%) loops seamlessly
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      row.appendChild(clone);
      var per = parseFloat(row.getAttribute('data-speed') || '7');
      track.style.setProperty('--dur', (track.children.length * per) + 's');
      clone.style.setProperty('--dur', (track.children.length * per) + 's');
    });
  }

  // --- wide tables ------------------------------------------
  // A table pasted into page copy has no width limit of its own, so on a
  // narrow screen it pushes the whole document sideways. Give each one a
  // scroller of its own instead. Idempotent: a table already wrapped is
  // skipped, so a customizer re-render cannot double-wrap it.
  function initTables(root) {
    root.querySelectorAll('.rte table').forEach(function (t) {
      var p = t.parentNode;
      if (!p || p.classList.contains('pp-tablewrap')) return;
      var w = document.createElement('div');
      w.className = 'pp-tablewrap';
      p.insertBefore(w, t);
      w.appendChild(t);
    });
  }

  function initSection(root) {
    if (!root) return;
    initReveal(root);
    initMarquee(root);
    initTables(root);
  }

  function initAll() {
    initSection(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Re-hydrate only the section the customizer just replaced.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    if (!root) return;
    root.querySelectorAll('[data-pp-marquee] .pp-marquee__track[aria-hidden="true"]').forEach(function (n) { n.remove(); });
    root.querySelectorAll('.pp-rise').forEach(function (el) { delete el.dataset.ppRise; el.classList.remove('is-pending'); el.classList.add('is-in'); });
    root.querySelectorAll('[data-pp-marquee]').forEach(function (el) { delete el.dataset.ppMarqueeInit; });
    initSection(root);
  });

  // keep cart bubble fresh when Dawn's own cart events fire
  document.addEventListener('pp:cart:refresh', function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-pp-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
      });
    });
  });

  // --- cart bubble visibility -------------------------------
  // The header renders the count with a hidden attribute while the cart is
  // empty. pp-pdp.js writes the new number straight into the element after an
  // ajax add but never clears that attribute, so the first Add to Cart on a
  // freshly loaded page updated the number and left the badge invisible; only
  // the second one showed, because the pp:cart:refresh handler above had
  // unhidden it by then. Watching the text instead of patching each writer
  // keeps the badge honest whichever code path sets it, now or later.
  // Only childList and characterData are observed, never attributes, so
  // setting hidden here cannot retrigger the observer.
  function syncCount(el) {
    var n = parseInt(String(el.textContent || '').replace(/[^0-9]/g, ''), 10);
    el.hidden = !(n > 0);
  }
  function watchCount() {
    document.querySelectorAll('[data-pp-cart-count]').forEach(function (el) {
      if (el.dataset.ppCountWatched === '1') return;
      el.dataset.ppCountWatched = '1';
      syncCount(el);
      new MutationObserver(function () { syncCount(el); })
        .observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCount, { once: true });
  } else {
    watchCount();
  }
  document.addEventListener('shopify:section:load', watchCount);

  /* ---------------------------------------------------------
     3. STICKY HEADER STACK
     --------------------------------------------------------- */
  /* The announcement bar pins at the very top and the header pins directly
     under it. CSS alone cannot do the second half: the bar's height is not a
     constant, because its sentence wraps to two or three lines on a phone. So
     the height is measured here and published as --pp-annh, which is what the
     header's own sticky offset reads.

     Measured again on resize, after web fonts land (the load event), and when
     the customizer swaps either section out. If the bar is not pinned, or is
     not on the page at all, the value is 0 and the header pins to the top. */
  function ppAnnEl() { return document.querySelector('.pp-section-announcement'); }
  function syncAnnHeight() {
    var a = ppAnnEl();
    var h = 0;
    if (a && getComputedStyle(a).position === 'sticky') {
      /* One pixel of overlap, never a gap. The bar's height is often
         fractional (it depends on the visitor's fonts and zoom), and rounding
         54.6px up to 55 pinned the header a fraction below the bar: a hairline
         gap that showed the page scrolling underneath. Pinning the header up
         to one pixel higher tucks it over the bar's bottom padding instead,
         and the header paints on top (z-index 90 over 89), so the two always
         meet at any zoom. */
      h = Math.max(0, Math.ceil(a.getBoundingClientRect().height) - 1);
    }
    document.documentElement.style.setProperty('--pp-annh', h + 'px');
    /* the pinned header's own height, for anything else that pins under it
       (the contact form column reads this) */
    var hd = document.querySelector('.pp-section-header');
    var hh = hd ? Math.round(hd.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--pp-headh', hh + 'px');
    ppFitSticky(h + hh);
  }

  /* Panels that pin under the header ([data-pp-sticky], the contact form).
     Where the whole panel fits under the header it pins 24px below it. On a
     shorter screen it pins with its bottom edge 16px above the fold, which
     tucks its empty top padding under the header. If that would hide more
     than the padding, it does not pin, so no field is ever stuck out of
     sight. The section's CSS reads data-pp-sticky and --pp-sticky-top. */
  function ppFitSticky(under) {
    var els = document.querySelectorAll('[data-pp-sticky]');
    if (!els.length) return;
    if (under == null) {
      var rs = getComputedStyle(document.documentElement);
      under = (parseFloat(rs.getPropertyValue('--pp-annh')) || 0) + (parseFloat(rs.getPropertyValue('--pp-headh')) || 0);
    }
    var vh = window.innerHeight;
    Array.prototype.forEach.call(els, function (el) {
      var pad = parseFloat(getComputedStyle(el).paddingTop) || 0;
      var ideal = under + 24;
      var fit = vh - el.offsetHeight - 16;
      if (fit >= ideal || fit >= under - pad) {
        el.setAttribute('data-pp-sticky', 'on');
        el.style.setProperty('--pp-sticky-top', Math.floor(Math.min(ideal, fit)) + 'px');
      } else {
        el.setAttribute('data-pp-sticky', 'off');
        el.style.removeProperty('--pp-sticky-top');
      }
    });
  }
  if ('ResizeObserver' in window) {
    var ppStickyRO = new ResizeObserver(function () { ppFitSticky(); });
    var ppWatchSticky = function () {
      ppStickyRO.disconnect();
      Array.prototype.forEach.call(document.querySelectorAll('[data-pp-sticky]'), function (el) { ppStickyRO.observe(el); });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ppWatchSticky, { once: true });
    } else {
      ppWatchSticky();
    }
    document.addEventListener('shopify:section:load', ppWatchSticky);
  }
  syncAnnHeight();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAnnHeight, { once: true });
  }
  window.addEventListener('load', syncAnnHeight);
  window.addEventListener('resize', syncAnnHeight);
  document.addEventListener('shopify:section:load', syncAnnHeight);
  if ('ResizeObserver' in window) {
    var ppAnnRO = new ResizeObserver(syncAnnHeight);
    var ppAnn0 = ppAnnEl();
    if (ppAnn0) ppAnnRO.observe(ppAnn0);
    document.addEventListener('shopify:section:load', function () {
      var a = ppAnnEl();
      if (a) { ppAnnRO.disconnect(); ppAnnRO.observe(a); }
    });
  }
})();
